import { type IToggleItem } from '@shared/models';

export const NAV_ITEMS: IToggleItem[] = [
  {
    label: 'Chatbot',
    route: '/chatbot',
    exact: false,
  },
  {
    label: 'Settings',
    route: '/settings',
    exact: false,
  },
];
